import React, { useState } from 'react';

function Contact() {
  const [result, setResult] = React.useState('');
  const [bgColor, setBgColor] = useState('#65B0DF');

  const onSubmit = async (event) => {
    event.preventDefault();
    setResult('Sending....');
    const formData = new FormData(event.target);

    formData.append('access_key', '991ae112-f514-44dc-bb8d-f810f2b5b39d');

    const response = await fetch('https://api.web3forms.com/submit', {
      method: 'POST',
      body: formData,
    });

    const data = await response.json();

    if (data.success) {
      setResult(
        'Thank you for reaching out! We’ve received your message and will get back to you as soon as possible.'
      );
      event.target.reset();
    } else {
      console.log('Error', data);
      setResult(data.message);
    }
  };
  return (
    <div>
      <section id="contact" class="contact" style={{ scrollMarginTop: '20px' }}>
        <div class="container" data-aos="fade-up">
          <div class="section-title">
            <br />
            <h2>Contact Us</h2>
            <p>
              Please fill out the form below, and we will reach out to you soon.
              You can also contact us via email or WhatsApp using the details
              provided below. We’re here to assist you!
            </p>
          </div>

          <div class="row">
            <div class="col-lg-5 d-flex align-items-stretch">
              <div class="info">
                <div class="address">
                  <i class="bi bi-geo-alt"></i>
                  <h4>Location:</h4>
                  <p>
                    Enterprising Zone, Opposite Bihar Museum, Ram Swarup Path,
                    Bailey Road, Patna, Bihar - 800001
                  </p>
                </div>

                <div class="email">
                  <i class="bi bi-envelope"></i>
                  <h4>Email:</h4>
                  <p>contact@softskart.com</p>
                </div>

                <div class="phone">
                  <i class="bi bi-phone"></i>
                  <h4>Whatsapp:</h4>
                  <p>+91 98608 11038</p>
                </div>

                <div style={{ width: '400px', position: 'relative' }}>
                  <iframe
                    title="gmap"
                    width="384"
                    height="240"
                    src="https://maps.google.com/maps?width=700&amp;height=440&amp;hl=en&amp;q=BEA%20-%20Patna+(Title)&amp;ie=UTF8&amp;t=&amp;z=10&amp;iwloc=B&amp;output=embed"
                    frameborder="0"
                    scrolling="no"
                    marginheight="0"
                    marginwidth="0"
                  ></iframe>
                  <div
                    style={{
                      position: 'absolute',
                      width: '80%',
                      bottom: '10px',
                      left: 0,
                      right: 0,
                      marginLeft: 'auto',
                      marginRight: 'auto',
                      color: '#000',
                      texAlign: 'center',
                    }}
                  >
                    <small
                      style={{
                        lineHeight: 1.8,
                        fontSize: '2px',
                        background: '#fff',
                      }}
                    >
                      Powered by{' '}
                      <a href="http://www.googlemapsgenerator.com/en/">
                        Googlemapsgenerator.com/en/
                      </a>{' '}
                      &{' '}
                      <a href="https://nouc.se/lan-med-lag-kreditvardighet/">
                        lån trots låg kreditvärdighet
                      </a>
                    </small>
                  </div>
                  {/* <style>#gmap_canvas img{max-width:none!important;background:none!important}</style> */}
                </div>
                <br />
              </div>
            </div>

            <div class="col-lg-7 mt-5 mt-lg-0 d-flex align-items-stretch text-start">
              <form
                action="https://api.web3forms.com/submit"
                method="POST"
                className="container p-4 rounded shadow-lg bg-light"
                onSubmit={onSubmit}
              >
                <input
                  type="hidden"
                  name="access_key"
                  value="991ae112-f514-44dc-bb8d-f810f2b5b39d"
                />

                <h3 className="mb-4 text-center">Contact Us</h3>

                <div className="row mb-3">
                  <div className="col-md-6">
                    <label htmlFor="name" className="form-label">
                      Your Name
                    </label>
                    <input
                      type="text"
                      name="name"
                      className="form-control"
                      id="name"
                      required
                      placeholder="Enter your full name"
                    />
                  </div>
                  {/* <div className="col-md-6">
                    <label htmlFor="phone" className="form-label">
                      Mobile Number
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="phone"
                      id="phone"
                      required
                      placeholder="Enter your mobile number"
                    />
                  </div> */}
                </div>

                <div className="mb-3">
                  <label htmlFor="email" className="form-label">
                    Your Email
                  </label>
                  <input
                    type="email"
                    className="form-control"
                    name="email"
                    id="email"
                    required
                    placeholder="Enter your email address"
                  />
                </div>

                <div className="mb-3">
                  <label htmlFor="subject" className="form-label">
                    Subject
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="subject"
                    id="subject"
                    required
                    placeholder="Subject of your message"
                  />
                </div>

                <div className="mb-3">
                  <label htmlFor="message" className="form-label">
                    Message
                  </label>
                  <textarea
                    className="form-control"
                    name="message"
                    rows="5"
                    id="message"
                    required
                    placeholder="Write your message here..."
                  ></textarea>
                </div>

                <span className="text-success">{result}</span>
                <br />

                <div className="text-center">
                  <button
                    type="submit"
                    className="btn btn-primary px-4"
                    style={{
                      backgroundColor: bgColor,
                      borderColor: '#65B0DF',
                      color: '#fff',
                      fontWeight: 'bold',
                    }}
                    onMouseEnter={() => setBgColor('#519cc8')}
                    onMouseLeave={() => setBgColor('#65B0DF')}
                  >
                    Send Message
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Contact;
